import type { PersonalizedFertilizerPdpResponse } from "@halm-club/halm-shared";

export type FertilizerVariant =
  PersonalizedFertilizerPdpResponse["variants"][number];
export type FertilizerPurchaseOption =
  FertilizerVariant["purchaseOptions"][number];

export const getFertilizerPurchaseOption = (
  variant: FertilizerVariant,
  purchaseType: FertilizerPurchaseOption["purchaseType"],
) =>
  variant.purchaseOptions.find(
    (option) => option.purchaseType === purchaseType,
  );

export const getInitialFertilizerLawnSize = (
  fertilizer: Pick<
    PersonalizedFertilizerPdpResponse,
    "preselectedLawnSize" | "variants"
  >,
) => {
  const { preselectedLawnSize, variants } = fertilizer;

  if (
    preselectedLawnSize !== undefined &&
    variants.some((variant) => variant.lawnSize === preselectedLawnSize)
  ) {
    return preselectedLawnSize;
  }

  return variants[0]?.lawnSize ?? null;
};

export const getSelectedFertilizerVariant = (
  variants: FertilizerVariant[],
  selectedLawnSize: number | null,
) =>
  variants.find((variant) => variant.lawnSize === selectedLawnSize) ??
  variants[0] ??
  null;
